interface SchieldWithCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const SchieldWithCheckmarkSVG = ({
  color,
  style,
}: SchieldWithCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12449)">
      <path
        d="M19.8602 3.5976L6.71387 10.4951V21.6583C6.71387 29.5804 12.153 36.4635 19.8602 38.2958C27.5675 36.4635 33.0066 29.5804 33.0066 21.6583V10.4951L19.8602 3.5976Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.5557 13.4222V21.6583C11.5557 26.9693 14.9166 31.5883 19.8599 33.2636C24.8032 31.5883 28.1642 26.9693 28.1642 21.6583V13.4222L19.8599 9.06558L11.5557 13.4222Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.99561 5.58896V10.6314H6.84614"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.57743 3.27532C5.57743 4.70068 4.42062 5.85749 2.99526 5.85749C1.5699 5.85749 0.413086 4.70068 0.413086 3.27532C0.413086 1.84996 1.5699 0.693146 2.99526 0.693146C4.42062 0.693146 5.57743 1.84996 5.57743 3.27532Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.7251 5.58896V10.6314H32.9985"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.1431 3.27532C34.1431 4.70068 35.2999 5.85749 36.7252 5.85749C38.1506 5.85749 39.3074 4.70068 39.3074 3.27532C39.3074 1.84996 38.1506 0.693146 36.7252 0.693146C35.2999 0.693146 34.1431 1.84996 34.1431 3.27532Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.99561 34.6911V29.6486H8.69498"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.57743 37.0047C5.57743 35.5793 4.42062 34.4225 2.99526 34.4225C1.5699 34.4225 0.413086 35.5793 0.413086 37.0047C0.413086 38.43 1.5699 39.5869 2.99526 39.5869C4.42062 39.5869 5.57743 38.43 5.57743 37.0047Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.7248 34.6911V29.6486H31.0254"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M34.1431 37.0047C34.1431 35.5793 35.2999 34.4225 36.7252 34.4225C38.1506 34.4225 39.3074 35.5793 39.3074 37.0047C39.3074 38.43 38.1506 39.5869 36.7252 39.5869C35.2999 39.5869 34.1431 38.43 34.1431 37.0047Z"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.1895 20.3817L19.255 23.408L23.936 18.727"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M0.413086 20.14H6.38513"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.335 20.14H39.307"
        stroke={color}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12449">
        <rect
          width="39.72"
          height="39.72"
          fill={color}
          transform="translate(0 0.279999)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SchieldWithCheckmarkSVG;
